import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'

export function EditTeamMemberProfileContent() {
  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <div className="flex sm:flex-row flex-col gap-stack-section">
        <FormFieldGroup>
          <FormLabel htmlFor={Input.FirstName}>
            First Name
          </FormLabel>

          <FormInput
            name={Input.FirstName}
            placeholder="Enter team member's first name..."
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.LastName}>
            Last Name
          </FormLabel>

          <FormInput
            name={Input.LastName}
            placeholder="Enter team member's last name..."
          />
        </FormFieldGroup>
      </div>
    </div>
  )
}
